export enum TournamentState {
    UNAVAILABLE,
    STARTED,
    FINISHED,
    PLANNED
}
